import React, { useContext } from 'react';

import { isModule } from '../../helpers/windowLocation';
import { InfoContext } from '../../context';
import { ConvertToPDFButton } from './ConvertToPDFButton';
import { UploadButton } from './UploadButton';
import { AbilityContext } from '../../abilities/Can';
import { CTAWorkflow } from './CTAWorkflow';
import { CTAWorkflow as OldCTAWorkflow } from './CTAWorkflow/CTAWorkflow';
import { useSplit } from '../../helpers/useSplit';

/*
 * bynder-platform/bynder/views/navigation/header.cfm
 * TODO: Move JQuery logic. Search for it using "uploadContainer" id
 */

export function CTAButton() {
	const { primaryCTA } = useContext(InfoContext);
	const ability = useContext(AbilityContext);

	const useNewWorkflowButton = useSplit('workflow_new_createnew_button');

	if (isModule('workflow')) {
		if (!useNewWorkflowButton) {
			return <OldCTAWorkflow />;
		}

		return <CTAWorkflow />;
	}

	if (primaryCTA.id !== 'uploadMedia') {
		return <ConvertToPDFButton />;
	}

	const canShowUpload = ability.can('show', 'upload_media');

	if (canShowUpload) {
		return <UploadButton />;
	}

	return null;
}
